import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, unref as _unref, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/icons/doctorAvatar.svg'


const _hoisted_1 = { class: "flex flex-col gap-1" }
const _hoisted_2 = { class: "flex items-center gap-2 flex-wrap" }
const _hoisted_3 = { class: "flex items-center bg-gray-50 rounded-lg border border-gray-100 p-1 pr-3 shadow-sm" }
const _hoisted_4 = { class: "flex flex-col px-2" }
const _hoisted_5 = { class: "text-base md:text-xl font-bold text-gray-700 leading-tight" }
const _hoisted_6 = { class: "font-bold text-lg md:text-2xl text-textPrimary" }
const _hoisted_7 = {
  key: 0,
  class: "text-xs md:text-sm text-primary50 break-words"
}
const _hoisted_8 = {
  key: 0,
  class: "flex gap-2 text-sm"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold text-gray-500" }, "Alocado por:", -1)
const _hoisted_10 = {
  key: 1,
  class: "flex flex-col text-sm leading-relaxed"
}
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "font-bold" }
const _hoisted_13 = { class: "font-bold" }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { class: "font-bold" }
const _hoisted_16 = { class: "font-bold" }
const _hoisted_17 = {
  key: 2,
  class: "text-xs text-gray-500 mt-0.5"
}
const _hoisted_18 = {
  key: 2,
  class: "flex flex-col md:flex-row flex-1 relative justify-center p-3 gap-4 md:gap-8 py-4 px-4 md:px-6 border border-gray-200 rounded-lg shadow-sm bg-white text-sm leading-relaxed text-left"
}
const _hoisted_19 = { class: "flex flex-col items-center justify-center w-full md:w-32" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Avatar do médico",
  class: "w-10 h-10 rounded-full object-cover"
}, null, -1)
const _hoisted_21 = { class: "text-lg mt-1 text-center" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "hidden md:block w-px bg-gray-200 h-auto self-stretch" }, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "block md:hidden w-full h-px bg-gray-200 self-stretch" }, null, -1)
const _hoisted_24 = { class: "flex flex-1 flex-col gap-1 text-center justify-center md:text-left" }
const _hoisted_25 = { class: "text-base" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("strong", null, "Formação:", -1)
const _hoisted_27 = { class: "text-base" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("strong", null, "Equipe:", -1)
const _hoisted_29 = { class: "text-base" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("strong", null, "Posição:", -1)
const _hoisted_31 = { class: "text-base" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("strong", null, "Turno:", -1)

import { computed } from 'vue'
import { getFirstAndSecondName } from '@/utils/getFirstAndSecondName'
import { capitalizeFirstLetter } from '@/utils/string'
import { getDutyTagBgClass, getDutyTagBorderClass } from '@/utils/doctorStation'
import ObservationList from '@/components/ObservationList.vue'

export interface BestCandidateDoctor {
  name: string
  crm: string
  formation: string
  team: string
  position: string
  shift: string
  dutyLabel: string
}

export interface BestCandidateDateInfo {
  weekday: string
  date: string
  time: string
}

export interface BestCandidateObservation {
  author: string
  timestamp: string
  text: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CardBestCandidate',
  props: {
    stationId: {},
    stationType: {},
    title: { default: 'Detalhes do Plantão' },
    breadcrumb: {},
    allocatedBy: {},
    startDate: {},
    endDate: {},
    timezone: {},
    doctor: {},
    observations: {},
    active: { type: Boolean, default: false },
    selectable: { type: Boolean, default: false }
  },
  emits: ["select"],
  setup(__props: any, { emit }) {

const props = __props;





const doctorDisplayName = computed(() => getFirstAndSecondName(props.doctor?.name ?? ''))

const dutySource = computed(() => props.stationType ?? props.doctor?.dutyLabel ?? '')

const capitalizedDutyLabel = computed(() =>
  dutySource.value ? capitalizeFirstLetter(dutySource.value) : ''
)

const dutyBgColor = computed(() => {
  return `${getDutyTagBgClass(dutySource.value)} ${getDutyTagBorderClass(dutySource.value)}`
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flex flex-col gap-4 bg-white rounded-xl shadow-sm p-4 md:p-6 text-left w-full", [
      _ctx.active ? 'border-2 border-primary30' : 'border border-gray-200',
      _ctx.selectable ? 'cursor-pointer' : ''
    ]]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectable ? emit('select') : undefined))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, " #" + _toDisplayString(_ctx.stationId), 1)
          ])
        ]),
        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.title), 1)
      ]),
      (_ctx.breadcrumb)
        ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.breadcrumb), 1))
        : _createCommentVNode("", true)
    ]),
    (_ctx.allocatedBy)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("span", null, _toDisplayString(_ctx.allocatedBy), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.startDate || _ctx.endDate)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          (_ctx.startDate)
            ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                _createTextVNode(" De "),
                _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.startDate.weekday) + ",", 1),
                _createTextVNode(" " + _toDisplayString(_ctx.startDate.date) + " ", 1),
                _createElementVNode("span", _hoisted_13, "às " + _toDisplayString(_ctx.startDate.time), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.endDate)
            ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                _createTextVNode(" Até "),
                _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.endDate.weekday) + ",", 1),
                _createTextVNode(" " + _toDisplayString(_ctx.endDate.date) + " ", 1),
                _createElementVNode("span", _hoisted_16, "às " + _toDisplayString(_ctx.endDate.time), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.timezone)
            ? (_openBlock(), _createElementBlock("span", _hoisted_17, "Horário de " + _toDisplayString(_ctx.timezone), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.doctor)
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
          _createElementVNode("span", {
            class: _normalizeClass([
          'absolute top-2 left-2 text-xs text-gray-600 border px-1 py-0.5 rounded',
          dutyBgColor.value
        ])
          }, _toDisplayString(capitalizedDutyLabel.value), 3),
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _createElementVNode("p", _hoisted_21, _toDisplayString(doctorDisplayName.value), 1),
            _createElementVNode("p", null, [
              _createElementVNode("strong", null, _toDisplayString(_ctx.doctor.crm), 1)
            ])
          ]),
          _hoisted_22,
          _hoisted_23,
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("p", _hoisted_25, [
              _hoisted_26,
              _createTextVNode(" " + _toDisplayString(_ctx.doctor.formation?.trim().length ? _ctx.doctor.formation : 'Não informado'), 1)
            ]),
            _createElementVNode("p", _hoisted_27, [
              _hoisted_28,
              _createTextVNode(" " + _toDisplayString(_ctx.doctor.team?.trim().length ? _ctx.doctor.team : 'Não informado'), 1)
            ]),
            _createElementVNode("p", _hoisted_29, [
              _hoisted_30,
              _createTextVNode(" " + _toDisplayString(_ctx.doctor.position?.trim().length ? _ctx.doctor.position : 'Não informado'), 1)
            ]),
            _createElementVNode("p", _hoisted_31, [
              _hoisted_32,
              _createTextVNode(" " + _toDisplayString(_ctx.doctor.shift?.trim().length ? _unref(capitalizeFirstLetter)(_ctx.doctor.shift) : 'Não informado'), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.observations?.length)
      ? (_openBlock(), _createBlock(ObservationList, {
          key: 3,
          observations: _ctx.observations
        }, null, 8, ["observations"]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})